import React from "react"; 



const SrFixationForm5 = ({ formData, setFormData, onBack, onNext }) => {
  
  const handleInputChange = ({ target: { name, value } }) => {
    onFormDataChange({ [name]: value });
  };

  return (
  <div className="google_forms">
      <div className="forms">
    <form className="seventh-pay-arrears-form">
        <h3>प्रशिक्षण तपशील </h3>


    <label>
        प्रशिक्षण स्थळ:
        <input type="text"  name="trainingLocation" value={formData.trainingLocation}  onChange={handleInputChange}/>
    </label>

    <label>
        प्रशिक्षण कालावधी:
        <input type="text"  name="trainingDuration" value={formData.trainingDuration}  onChange={handleInputChange}/>
    </label>



      {/* Navigation Buttons */}
      <div className="seventh-pay-arrears-buttons-container">
        <button type="button" onClick={onBack}>Back</button>
        <button type="button" onClick={onNext}>
         Next
        </button>
      </div>
    </form>
    </div>
    </div>
  );
};

export default SrFixationForm5;
